





























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Mall } from 'supporter';
import _ from 'underscore';

import { makeFastFuncOfGetI18n } from '@/utils/i18n';
import SearchForm from '@/components/order/detail/orderRecurringPayments/SearchForm.vue';
import SearchResult from '@/components/order/detail/orderRecurringPayments/SearchResult.vue';

@Component({
  components: {
    SearchForm,
    SearchResult,
  }
})
export default class OrderRecurringPayments extends Vue {
  private getI18nOfThis = makeFastFuncOfGetI18n('RECURRINGPAYMENTS_ORDER');

  @Getter('mall/mallsSortedByCreationDate')
  private mallsSortedByCreationDate!: Mall[];
  private noticeList: string[] = _.range(1, 3)
                                  .map(number => this.getI18nOfThis(`PAGE_DESCRIPTION_${number}`));

  private mounted() {
    let descriptionAboutTerms = this.getI18nOfThis('PAGE_DESCRIPTION_ABOUT_TERMS');
    if (this.mallsSortedByCreationDate.length) {
      descriptionAboutTerms += ' ' + `<a href="/terms/tab/e-commerce?mallNo=${this.mallsSortedByCreationDate[this.mallsSortedByCreationDate.length - 1].mallNo}" target="_blank" rel="noopener noreferrer">${this.getI18nOfThis('GO_TO_TERMS_OF_USE')}</a>`
    }
    this.noticeList.push(descriptionAboutTerms);
  }
}

